import React from 'react';
import ProfileMenu from './ProfileMenu';
import NotificationMenu from './NotificationMenu';
import ThemeSwitcher from './ThemeSwitcher';

const Header = () => (
  <nav
    className="layout-navbar container-fluid navbar navbar-expand-xl navbar-detached align-items-center bg-navbar-theme"
    id="layout-navbar"
  >
    <div className="layout-menu-toggle navbar-nav align-items-xl-center me-4 me-xl-0 d-xl-none">
      <span className="layout-menu-toggle menu-link text-large ms-auto nav-item nav-link px-0 me-xl-6" role="button" tabIndex={0}>
        <i className="ri-menu-fill ri-22px"></i>
      </span>
    </div>
    <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
      <ul className="navbar-nav flex-row align-items-center ms-auto">
        <NotificationMenu />
        {/* <ThemeSwitcher /> */}
        <ProfileMenu />
      </ul>
    </div>
    <div className="navbar-search-wrapper search-input-wrapper d-none">
      <input
        type="text"
        className="form-control search-input container-fluid border-0"
        placeholder="Search..."
        aria-label="Search..."
      />
      <i className="ri-close-fill search-toggler cursor-pointer"></i>
    </div>
  </nav>
);

export default Header;
